import React from 'react';
import alertTypes from '../../../shared/alertTypes';
import FormAlert from '../../../shared/forms/formAlert.component';
import EditCurrencyCodeAlertContent from './editCurrencyCodeAlertContent.component';

const EditCurrencyCodeModalAlert = ({ hidden }: { hidden: boolean }) => (
  <FormAlert hidden={hidden} content={<EditCurrencyCodeAlertContent />} type={alertTypes.WARNING} />
);

export default EditCurrencyCodeModalAlert;
